<template>
  <v-container fluid>
    <v-layout justify-center>
      <v-flex xs12 sm12>
        <DataTableMain :datatable="table" :on-success="successAction" :itemsAction="tableAction"/>
      </v-flex>
    </v-layout>
    <v-layout justify-center class="mt-4">
      <v-flex xs12 sm10 md8>
        <ViewDetails class="ma-2" :object="object" type="LogsApp" :itemsAction="tableAction"/>
      </v-flex>
    </v-layout>
    <MainFormDialog v-if="get_dialogMain.dialog" :fields="form" :model="objectMain" :urls="url" :message="message" />
  </v-container>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import DataTableMain from '@/components/tables/DataTableMain'
import MainFormDialog from '@/components/dialogs/MainFormDialog'
import ViewDetails from '@/components/ViewDetails'
import { Permission } from '@/mixins/permissionMain'

export default {
  mixins: [Permission],
  data: () => ({
    table: {
      modelMain: [],
      showSelect: true,
      singleSelect: true,
      header: {
        options: [
          { title: 'Refrescar', icon: 'mdi-cached', color: 'primary', action: 'refreshData', code: 'libre', hidden: '' }
          // { title: 'Nuevo', icon: 'mdi-plus', color: 'success', action: 'newData', code: 'asist.resumenhoras-create' }
        ],
        titles: [
          { text: 'Cve Departamento', value: 'cve_departamento', class: 'black--text' },
          { text: 'Departamento', value: 'departamento.nombre', class: 'black--text' },
          { text: 'Mac Address', value: 'mac_address', class: 'black--text' },
          { text: 'Serial', value: 'serial', class: 'black--text' },
          { text: 'Descripcion', value: 'descripcion', class: 'black--text' },
          { text: 'Activo', value: 'Activo', class: 'black--text' }
          // { text: '', value: 'ActionsLocal', class: 'black--text' }
        ],
        loading: false
      },
      body: {
        data: [],
        actions: [
          { title: 'Editar', icon: 'mdi-pencil', color: 'yellow darken-3', action: 'updateData', code: 'asist.log-app-create' }
        ]
      },
      footer: {
        paging: true
      }
    },
    params: { activo: 'si' },
    form: [],
    objectMain: {},
    url: {},
    message: ''
  }),
  components: {
    DataTableMain,
    MainFormDialog,
    ViewDetails
  },
  mounted () {
    this.ShowPermisos({ permisos: JSON.parse(localStorage.getItem('permisos')), tableMain: this.table })
    this.getUrl('POST/asistencia/logapp/show')
  },
  methods: {
    ...mapActions(['getUrlServices', 'postServiceListAction']),
    ...mapMutations(['SHOW_DIALOG_MAIN', 'CLEAR_DATA_LIST']),
    successAction (item) {
      this[item.action](item)
    },
    refreshData (item) {
      this.table.header.loading = true
      this.getUrl('POST/asistencia/logapp/show')
    },
    newData (item) {
      this.form = this.get_incidencia_form
      this.object = {}
      this.url = this.get_urls['POST/asistencia/resumen-horas/new']
      this.message = 'Registro Agregado Correctamente'
      this.SHOW_DIALOG_MAIN({ type: 'create', with: 850, title: 'Nueva Incidencia' })
    },
    importData (item) {
      this.object = {}
      this.form = this.get_fileIncidencia
      this.url = this.get_urls['POST/asistencia/resumen-horas/importar']
      this.message = 'Importacion Agregado Correctamente'
      this.SHOW_DIALOG_MAIN({ type: 'fileSend', with: 950, title: 'Importar Incidencia', body: { content: 'form-data' } })
    },
    tableAction (item) {
      this[item.action](item.item)
    },
    updateData (item) {
      if (item.especial.procesado) {
        this.$swal({
          type: 'warning',
          icon: 'warning',
          title: 'Advertencia!',
          text: 'El horario no se puede modificar ya esta procesado a la nomina'
        })
        return
      }
      this.form = this.get_incidencia_form
      this.object = item
      this.url = this.get_urls['POST/asistencia/resumen-horas/new']
      this.message = 'Registro Agregado Correctamente'
      this.SHOW_DIALOG_MAIN({ type: 'create', with: 850, title: 'Actualizar Incidencia' })
    },
    getUrl (objet) {
      if (this.get_urls != null) {
        const router = this.get_urls[objet]
        this.postServiceListAction({ url: router, data: this.params })
      } else {
        this.getUrlServices()
      }
    }
  },
  computed: {
    ...mapGetters(['get_dialogMain', 'get_urls', 'get_incidencia_form', 'get_fileIncidencia', 'get_objects']),
    object () {
      if (this.table.modelMain.length > 0) {
        return this.table.modelMain[0]
      }
      return {}
    }
  },
  watch: {
    get_urls (val) {
      this.getUrl('POST/asistencia/logapp/show')
    },
    get_objects (vals) {
      if (vals) {
        this.table.modelMain = []
        if (vals.length > 0) {
          this.table.modelMain.push(vals[0])
        }
        this.table.header.loading = false
        this.table.body.data = vals
      }
    }
  },
  beforeDestroy () {
    this.CLEAR_DATA_LIST()
  }
}
</script>

<style>

</style>
